import React, { useRef } from 'react';
import classNames from 'classnames';
import SortableListItem from '@/components/ui/drag-and-drop/sortable-list-item/SortableListItem';
import { Icon, IconButton } from '@monash/portal-react';
import c from './edit-shortcut-mobile-row.module.scss';
import IconDisplay from '@/components/pages/custom/components/icon-display/IconDisplay';

export const EditShortcutMobileRow = ({ shortcut, setEditedId, isEditing }) => {
  const ref = useRef(null);

  return (
    <SortableListItem
      id={shortcut.id}
      ref={ref}
      className={classNames(c.editableShortcutContainer, {
        [c.shadow]: isEditing,
      })}
      itemLabel={shortcut.name}
    >
      <span>
        <IconDisplay icon={shortcut.icon} url={shortcut.url} />
      </span>

      <div className={c.name}>{shortcut.name}</div>

      <div className={c.buttons}>
        <IconButton
          onClick={() => {
            setEditedId(shortcut.id);
          }}
          variant="text"
          mode="card"
          icon={Icon.DotsHorizontal}
          size={24}
          aria-label="View shortcut menu"
          color="var(--card-cta-bg-color)"
        />
      </div>
    </SortableListItem>
  );
};
